import { Injectable } from '@angular/core';
import { LogService } from '../providers/index';
import JSZip from 'jszip';

@Injectable()
export class ZipService {
  public async unzip(file: Blob): Promise<{ data: Uint8Array; name: string }[]> {
    const jszip = new JSZip();

    const ret: { data: Uint8Array; name: string }[] = [];

    try {
      const extracted = await jszip.loadAsync(file);
      const files: JSZip.JSZipObject[] = Object.values(extracted.files);
      for (let i = 0, len = files.length; i < len; i++) {
        const file1 = files[i];
        const name1 = file1.name;
        const fileContent = jszip.file(name1);
        if (fileContent) {
          const uintFile = await fileContent.async('uint8array');
          ret.push({
            name: name1,
            data: uintFile,
          });
        }
      }
    } catch (e) {
      LogService.error(String(e));
    }
    return ret;
  }
}
